const api = jQuery.Zend.jsonrpc({url:'/_api.php', async:true});

const raty = () => {

    $('.raty').raty({ 
        starType: 'i',
        half: false,
        starHalf: 'icon-star-half-png',
        starOff: 'icon-star-off-png',
        starOn: 'icon-star-on-png',
        //hints: ['bardzo slało', 'słabo', 'całkiem ok', 'dobrze', 'super'],
		hints: [],
        target: '#raty-hint',
		number: 10,
		numberMax: 10,
		targetType: 'score',
		click: function(score) {
			if (typeof api.setGameRating == 'function') {
				api.setGameRating(0, score, {
					success: function(r) {
						if (r) {
							$('.user-game-score').html(score);
						}
					}
				});
			} else {
				alert('Zaloguj się aby dodać ocenę.');
			}
			
			return true;
		}
    });

    $('.raty-read-only').raty({
        starType: 'i',
        half: true,
        starHalf: 'icon-star-half-png',
        starOff: 'icon-star-off-png',
        starOn: 'icon-star-on-png',
        readOnly: true,
		number: 10,
		numberMax: 10
    })

    $('.raty-read-only').each(function(){
        let score = $(this).data("score")
        $(this).next('.score').html(score)

    })

    

}

module.exports = {
    raty
};